<div class="pb-3">
  <button
    type="button"
    class="btn btn-link ps-0 h3"
    (click)="searchVisible ? hideSearch() : showSearch()">
    <span *ngIf="!searchVisible">
      <app-caret-right-icon></app-caret-right-icon>
    </span>
    <span *ngIf="searchVisible">
      <app-caret-down-icon></app-caret-down-icon>
    </span>
    Search Order History
  </button>
</div>

<form *ngIf="searchVisible" class="bg-light p-4 mb-3" [formGroup]="searchForm" (submit)="submit()">
  <div class="row p-3">
    <div class="input-group">
      <input type="text"
             class="form-control"
             placeholder="Search"
             formControlName="query"
             id="query">
      <div class="input-group-append">
        <button type="submit"
                class="input-group-append btn btn-dark d-block text-uppercase px-4">
          Search
        </button>
      </div>
    </div>
  </div>


  <div class="row p-3">
    <div class="col-12 col-md-6 pb-4">
      <span class="h4">Search For</span>
      <div class="form-check">
        <input type="checkbox"
               class="form-check-input"
               id="productName"
               value="productName"
               formControlName="includeProductName">
        <label for="productName" class="form-check-label">Product Name</label>
      </div>
      <div class="form-check">
        <input type="checkbox"
               class="form-check-input"
               id="orderNumber"
               value="orderNumber"
               formControlName="includeOrderNumber">
        <label for="orderNumber" class="form-check-label">Order Number</label>
      </div>
      <div class="form-check">
        <input type="checkbox"
               class="form-check-input"
               id="orgId"
               value="orgId"
               formControlName="includeOrgId">
        <label for="orgId" class="form-check-label">Org ID (if provided)</label>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="h4">Date Range</div>
      <div class="row mb-2">
        <label for="beginDate"
               class="col-md-3 col-form-label order-md-1 ps-md-0 ps-3">
          From
        </label>
        <div class="col-md-9">
        <input type="date"
               class="form-control"
               id="beginDate"
               name="beginDate"
               formControlName="beginDate">
        </div>
      </div>
      <div class="row">
        <label for="endDate"
               class="col-md-3 col-form-label order-md-1 ps-md-0 ps-3">
          To
        </label>
        <div class="col-md-9">
        <input type="date"
               class="form-control"
               id="endDate"
               name="endDate"
               formControlName="endDate">
        </div>
    </div>
    </div>
  </div>

</form>
